export default __webpack_public_path__ + "static/media/01330000-6bec-ac1f-d1d2-08db28725502.491dcfab.webp";